/*=========================================================================================
  File Name: getters.js
  namespace: lpaths
  Description: Vuex Store - Learning Path getters
==========================================================================================*/
import {
  buildLPathState
} from './state'

const getters = {
  getCurrentLPath: state => {
    return state.currentLPath
  },
  getNewLPath: () => {
    return buildLPathState()
  },
  getLPathList: state => {
    return {
      results: state.results,
      count: state.count
    }
  },
  getLPathEntries: state => {
    return state.lpathList
  },
  getLPathStructure: state => {
    return state.content
  },
  lapthIsPublished: state => {
    return state.currentLPath.status !== state.LPATH_POSSIBLE_STATUS.PUBLISHED
  },
  getLPathPossibleStatus: state => {
    return state.lpathStatusTransitions[state.currentLPath.status].map((value) => {
      return {
        label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase().replace(/_/g, " "),
        value: value
      }
    })
  },
  getLPathAllStatus: state => {
    return Object.entries(state.LPATH_POSSIBLE_STATUS).map(([, value]) => {
      return {
        label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase().replace(/_/g, " "),
        value: value
      }
    })
  },
  getLPathStatusList: state => {
    return state.LPATH_POSSIBLE_STATUS
  },
  getLPathDifficulties: state => {
    return Object.entries(state.LPATH_POSSIBLE_DIFFICULTY).map(([, value]) => {
      return {
        label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
        value: value
      }
    })
  },
  getStatusTransitions: state => {
    return state.lpathStatusTransitions
  },
  getCurrentLPathPasses: state => {
    return state.currentLPath.direct_passes
  }
}

export default getters
